import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import SSO from './app/SSO'
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'))


const app = (ssoLogin) => root.render(
    <App ssoLogin={ssoLogin} />
);


SSO.initKeycloak(app);




//root.render(<App ssoLogin = {null}/>);

